import React from 'react';
import { Box } from '@mantine/core';
import { THEME_COLORS } from '../../theme/ThemeConstants';

const PAYMENT_METHODS = [
  { src: '/assets/images/accepted/visa.png', alt: 'Visa' },
  { src: '/assets/images/accepted/mastercard.png', alt: 'Mastercard' },
  { src: '/assets/images/accepted/amex.png', alt: 'American Express' },
  { src: '/assets/images/accepted/apple.svg', alt: 'Apple Pay' },
  { src: '/assets/images/accepted/google.png', alt: 'Google Pay' }
];

export const PaymentMethods: React.FC = () => {
  return (
    <Box
      style={{
        marginTop: 16,
        paddingTop: 16,
        borderTop: `1px solid ${THEME_COLORS.border.primary}`,
        display: 'flex',
        flexWrap: 'nowrap',
        gap: 4,
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      {PAYMENT_METHODS.map((method) => (
        <img
          key={method.alt}
          src={method.src}
          alt={method.alt}
          style={{
            height: 16,
            width: 'auto',
            opacity: 0.7,
            filter: 'grayscale(100%)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = '1';
            e.currentTarget.style.filter = 'grayscale(0%)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = '0.7';
            e.currentTarget.style.filter = 'grayscale(100%)';
          }}
        />
      ))}
    </Box>
  );
};

